"use client"

import Link from "next/link"
import { MapPin } from "lucide-react"
import { JobByState } from "@/lib/jobs/jobs.api"
import { useMauticTracking } from "@/hooks/useMauticTracking"

export function JobsByState({
   items,
   title,
   viewAllLink,
   viewAllText,
}: {
   items: JobByState[]
   title: string
   viewAllLink: string
   viewAllText: string
}) {
   const { trackEvent } = useMauticTracking()

   return (
      <div className="w-full shrink-0">
         <div className="flex flex-col">
            <h2 className="text-custom-3xl-bold text-title">{title}</h2>
            <div className="mb-4 mt-2 h-1 w-1/4 bg-custom-primary" />

            <ol className="grid gap-4 divide-y divide-separation-line pt-3">
               {items.map((item) => (
                  <li key={item.url} className="flex items-center justify-between gap-3 p-3 font-medium text-title">
                     <Link
                        href={item.url}
                        aria-label={`View jobs in ${item.state}`}
                        className="flex w-full items-center justify-between"
                        onClick={() => trackEvent("Jobs", "Job Click", item.state)}
                     >
                        <div className="flex items-center gap-3">
                           <MapPin className="h-5 w-5 text-jobs-icons" />
                           <p className="text-md font-medium capitalize underline decoration-transparent transition duration-300 hover:decoration-decoration-title">
                              {item.state}
                           </p>
                        </div>

                        <span className="text-md font-medium text-custom-primary">{item.count}</span>
                     </Link>
                  </li>
               ))}
            </ol>

            <Link href={viewAllLink} className="mt-4 text-base font-semibold text-custom-primary">
               {viewAllText}
               <span className="sr-only"> {title}</span>
               <span aria-hidden="true"> &rarr;</span>
            </Link>
         </div>
      </div>
   )
}
